import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IAssignedAdminRoles, IPaginatedResponse } from '@boma/client-shared';
import {
  IAdministrator,
  IVehicle,
} from '@boma/supplier-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadVehicles(
    entityId: string,
    page: string = '1',
    perPage: string = '25',
    query: string = ''
  ) {
    return this.httpClient.get<IPaginatedResponse<IVehicle>>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles`,
      {
        params: { page, perPage, query },
      }
    );
  }

  loadVehicle(entityId: string, id: string) {
    return this.httpClient.get<IVehicle>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${id}`
    );
  }

  createVehicle(entityId: string, location: IVehicle) {
    return this.httpClient.post<IVehicle>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles`,
      {
        ...location,
      }
    );
  }

  updateVehicle(entityId: string, locationId: string, location: IVehicle) {
    return this.httpClient.put<IVehicle>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}`,
      {
        ...location,
      }
    );
  }

  updateVehiclePermissions(
    entityId: string,
    vehicleId: string,
    userId: string,
    roleIds: string[]
  ) {
    return this.httpClient.put<IAssignedAdminRoles>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${vehicleId}/Drivers/${userId}`,
      {
        roleIds,
      }
    );
  }

  listDrivers(entityId: string, locationId: string, query: string = '') {
    return this.httpClient.get<IAdministrator[]>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}/Drivers`,
      {
        params: { query },
      }
    );
  }

  createDriver(
    entityId: string,
    locationId: string,
    emailAddressOrPhoneNumber: string,
    roleIds: string[]
  ) {
    return this.httpClient.post<IAdministrator>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}/Drivers`,
      {
        emailAddressOrPhoneNumber,
        roleIds,
      }
    );
  }

  loadDriverDetails(entityId: string, locationId: string, userId: string) {
    return this.httpClient.get<IAdministrator>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}/Drivers/${userId}`
    );
  }

  deleteDriver(entityId: string, locationId: string, userId: string) {
    return this.httpClient.delete(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}/Drivers/${userId}`
    );
  }

  updateDriver(
    entityId: string,
    locationId: string,
    userId: string,
    roleIds: string[]
  ) {
    return this.httpClient.put<IAdministrator>(
      `${this.base}api/v${this.version}/${entityId}/Vehicles/${locationId}/Drivers/${userId}`,
      {
        roleIds,
      }
    );
  }
}
